import {Component, Inject, Vue} from "vue-property-decorator";
import {EnvConfig} from "~/lib/env-config";
import {Getter} from "vuex-class";
import {AppSettings} from "~/lib/app-settings";

@Component
class NavGoBackLink extends Vue {
  @Getter session;
  @Getter authToken;
  @Inject() appSettings: AppSettings;

  get canPrevious() {
    return !!this.appSettings.clientUUID && this.appSettings.hasClients;
  }

  get gmsLink() {
    return this.session?.client?.dns ?
      `${this.session.client.dns}?token=${this.authToken}` :
      `${EnvConfig("FRONT_URL")}?token=${this.authToken}`;
  }

  private renderGmsAppFrontLink() {
    return (
      <a class="app-link" href={this.gmsLink}>Revenir à la solution</a>
    )
  }

  private renderHomePartnerPageLink() {
    return (
      <router-link class={"app-link"} to={{ name: 'partner_home' }}><span>Revenir aux comptes clients</span></router-link>
    )
  }

  render() {
    return this.canPrevious
      ? this.renderHomePartnerPageLink()
      : this.renderGmsAppFrontLink();
  }
}

export { NavGoBackLink }

// VUE JSX HOT LOADER //
if (module.hot) require("/usr/src/app/node_modules/vue-jsx-hot-loader/src/api.js")({ Vue: require('vue'), ctx: eval('this'), module: module, hotId: "_vue_jsx_hot-3a771a51/nav-go-back-link.tsx" });